<template>
  <div class="section-header">
    <div class="section-lead">
      <div class="section-icon" :style="{ background: tint, color: color }">
        <ExIcon :name="icon" />
      </div>
      <div class="section-text">
        <h2 class="section-title">{{ title }}</h2>
        <p v-if="subtitle" class="section-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <button v-if="seeAll" class="see-all" type="button" @click="$emit('see-all')">
      See all
      <ExIcon name="arrow" />
    </button>
  </div>
</template>

<script>
import ExIcon from "./ExIcon.vue";

export default {
  name: "SectionHeader",
  components: { ExIcon },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "trending-up" },
    color: { type: String, default: "#4E84FF" },
    seeAll: { type: Boolean, default: false },
  },
  emits: ["see-all"],
  computed: {
    tint() {
      const hex = this.color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.12)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.section-lead {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 7px;
  flex-shrink: 0;
  font-size: 22px;
}

.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
}

.section-subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #64748b;
}

.see-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: #4e84ff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;

  .ex-icon {
    font-size: 16px;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
